var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.776 9.48-13.5.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6.037 13.259-3.76-3.74 3.738-3.76"
  })));
};
export default SvgArrowBack;